import api from "@/lib/api";

export function openGoogleConnection(capabilities = ["drive", "gmail"]) {
  const popup = window.open("", "google_oauth", "width=520,height=640");
  if (!popup) return Promise.reject(new Error("The Google authorization popup was blocked."));

  return new Promise((resolve, reject) => {
    let settled = false;
    let poll;
    const finish = (fn, value) => {
      if (settled) return;
      settled = true;
      window.removeEventListener("message", onMessage);
      if (poll) window.clearInterval(poll);
      fn(value);
    };
    const onMessage = (event) => {
      if (event.origin !== window.location.origin || event.data?.type !== "google-oauth") return;
      if (event.data.ok) finish(resolve, event.data);
      else finish(reject, new Error(event.data.error || "Google authorization failed."));
    };
    window.addEventListener("message", onMessage);

    api.get("/oauth/google/auth-url", { params: { capabilities: capabilities.join(",") } })
      .then((response) => { popup.location.href = response.data.authorization_url; })
      .catch((error) => {
        popup.close();
        finish(reject, new Error(error?.response?.data?.detail || "Google authorization failed."));
      });

    poll = window.setInterval(() => {
      if (popup.closed) finish(reject, new Error("Google authorization was cancelled."));
    }, 800);
  });
}
